<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 backdrop-blur-sm bg-gray-800/70 flex items-center justify-center p-4"
    :style="{ zIndex: Z_INDEX.MODAL }"
    role="dialog"
    aria-modal="true"
    aria-labelledby="upload-dialog-title"
    @click.self="handleClose"
  >
    <div class="bg-white rounded-lg p-6 max-w-sm mx-4 w-full">
      <h3 id="upload-dialog-title" class="text-lg font-semibold text-gray-900 mb-4">
        Upload Files
      </h3>

      <div class="space-y-3">
        <!-- GPX/FIT Upload Button -->
        <button
          @click="handleGpxUpload"
          class="w-full flex items-center justify-center gap-3 px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 hover:cursor-pointer transition-colors"
        >
          <FilePlusIcon class="w-5 h-5 text-primary-500" />
          <span class="text-gray-900 font-medium">Import GPX/FIT Files</span>
        </button>

        <!-- Photo Upload Button -->
        <button
          v-if="allowPhotoUpload"
          @click="handlePhotoUpload"
          class="w-full flex items-center justify-center gap-3 px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 hover:cursor-pointer transition-colors"
        >
          <CameraIcon class="w-5 h-5 text-gray-500" />
          <span class="text-gray-900 font-medium">Add Photos</span>
        </button>
      </div>

      <!-- Cancel Button -->
      <div class="mt-6">
        <button
          @click="handleClose"
          class="w-full px-4 py-2 bg-gray-200 text-gray-800 rounded-lg font-medium hover:bg-gray-300 hover:cursor-pointer transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FilePlus as FilePlusIcon, CameraIcon } from '@lucide/vue'

import { Z_INDEX } from '@/utils/zIndex'

withDefaults(
  defineProps<{
    allowPhotoUpload?: boolean
    isOpen: boolean
  }>(),
  {
    allowPhotoUpload: true,
  },
)

const emit = defineEmits<{
  close: []
  'trigger-gpx-upload': []
  'trigger-photo-upload': []
}>()

const handleClose = () => {
  emit('close')
}

const handleGpxUpload = () => {
  emit('trigger-gpx-upload')
  handleClose()
}

const handlePhotoUpload = () => {
  emit('trigger-photo-upload')
  handleClose()
}
</script>
